import GetFontAwesomeIcon from "@/components/font-awesome-icon";
import { Enums } from "@/services/dropdown-enums";
import { groupBy } from "@/services/generic.methods";
import { ToastTemplate } from "@/services/variables";
import {
  faEnvelope,
  faMessage,
  faNoteSticky,
} from "@fortawesome/free-regular-svg-icons";
import {
  faAddressCard,
  faBolt,
  faGlobe,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const delayXPosition = (400 - 210) / 2 + 300;
// const conditionXPosition = (400 - 210) / 2 + 300;
const conditionXPosition = 175;
const addNodeXPosition = (400 - 20) / 2 + 300;
const endNodeXPosition = (400 - 70) / 2 + 300;
const customNodeWidth = 400;
const endNodeWidth = 70;
export const defaultXPosition = 300;
export const defaultYPosition = 60;
export const delayHeight = 43;
export const listHeight = 113;
export const smsHeight = 117;
export const initialNodeDefaultText = "Add automation starting criteria";

export const NodeTypes = {
  initial: { title: "Add List to start", icon: "" },
  list: { title: "", icon: "" },
  addNode: { title: "", icon: "", xPosition: addNodeXPosition },
  addConditionNode: { title: "", icon: "", xPosition: addNodeXPosition },
  endNode: { title: "End", icon: "", xPosition: addNodeXPosition },
  noneNode: { title: "None", icon: "", xPosition: addNodeXPosition },
  sms: { title: "SMS Template", icon: <GetFontAwesomeIcon icon={faMessage} /> },
  appointment: {
    title: "Appointment",
    icon: <GetFontAwesomeIcon icon={faNoteSticky} />,
  },
  email: {
    title: "Email Template",
    icon: <GetFontAwesomeIcon icon={faEnvelope} />,
  },
  delay: { title: "Delay", icon: "", xPosition: delayXPosition },
  dummyRoot: { title: "Root", icon: "", xPosition: delayXPosition },
  httpRequest: {
    title: "HTTP Request",
    icon: <GetFontAwesomeIcon icon={faGlobe} />,
    xPosition: delayXPosition,
  },
  trigger: {
    title: "Start Automation When",
    icon: <GetFontAwesomeIcon icon={faBolt} />,
    xPosition: delayXPosition,
  },
  condition: {
    title: "Condition",
    icon: <GetFontAwesomeIcon icon={faListCheck} />,
    xPosition: conditionXPosition,
  },
  leadAttribute: {
    title: "Change Lead Attribute",
    icon: <GetFontAwesomeIcon icon={faAddressCard} />,
    xPosition: defaultXPosition,
  },
};

export const NodeTypeEnum = {
  Initial: "initial",
  List: "list",
  SMS: "sms",
  Email: "email",
  HttpRequest: "httpRequest",
  DummyRoot: "dummyRoot",
  Delay: "delay",
  Trigger: "trigger",
  AddNode: "addNode",
  AddConditionNode: "addConditionNode",
  EndNode: "endNode",
  NoneNode: "noneNode",
  Condition: "condition",
  Appointment: "appointment",
  Task: "task",
  LeadAttribute: "leadAttribute",
};

export const CustomNodeTypes = [
  NodeTypeEnum.SMS,
  NodeTypeEnum.Email,
  NodeTypeEnum.HttpRequest,
  NodeTypeEnum.Task,
  NodeTypeEnum.List,
  NodeTypeEnum.EndNode,
  NodeTypeEnum.Appointment,
  NodeTypeEnum.DummyRoot,
];

export const getNodeX = (nodeType) => {
  switch (nodeType) {
    case NodeTypeEnum.Initial:
    case NodeTypeEnum.Email:
    case NodeTypeEnum.SMS:
    case NodeTypeEnum.HttpRequest:
    case NodeTypeEnum.DummyRoot:
    case NodeTypeEnum.List:
    case NodeTypeEnum.Trigger:
    case "custom":
      return 200;
    case NodeTypeEnum.Delay:
    case NodeTypeEnum.AddConditionNode:
      return 105;
  }
};

export const getAddNode = (
  id,
  prevNodeId,
  positionY,
  positionX = addNodeXPosition
) => ({
  id: makeId(id),
  type: "addNode",
  data: { label: "", nodeType: "addNode" },
  position: {
    x: getXPosition(prevNodeId, positionX / 2 - 10),
    // y: positionY + 100,
    y: getYPosition(prevNodeId, positionY),
  },
  className: "customNodeStyle",
});
export const getAddNodeEdge = (target, type = "straight") => ({
  id: makeEdgeId(target, makeId(target)),
  source: target,
  target: makeId(target),
  type: type,
});

export const createEndNode = (id, prevNodeId, prevNode, allNodes) => {
  let { x, y } = prevNode?.position;
  let domNodeWidth = getElementWidth(prevNode?.id) / 2;
  // let positionX =
  //   x >= 300 && prevNode?.type !== NodeTypeEnum.Condition
  //     ? endNodeXPosition
  //     : x + 70;
  let positionX = x + domNodeWidth - 35; // endNode width is 70 so half of it is 35 to show in center of parent node

  let endNode = {
    // id: makeId(id),
    // id: `${id}-end`,
    id: id,
    type: "endNode",
    data: { label: "End", nodeType: "endNode" },
    position: {
      x: positionX || endNodeXPosition,
      y: getYPosition(prevNodeId, y) - 30,
    },
    className: "customNodeStyle",
  };
  // let iterationCount = 0;
  // const maxIterations = 100;
  // while (true) {
  //   if (iterationCount > maxIterations) {
  //     console.warn(
  //       "Max iterations reached; breaking loop to avoid infinite loop."
  //     );
  //     break;
  //   }
  //   const overlappedNode = findOverlappedNode(endNode, allNodes);
  //   if (overlappedNode) {
  //     if (overlappedNode.position.x < endNode.position.x) {
  //       endNode.position.x = overlappedNode.position.x - (endNodeWidth + 30);
  //     } else {
  //       endNode.position.x =
  //         overlappedNode.position.x + (customNodeWidth + endNodeWidth + 30);
  //     }
  //   } else {
  //     break;
  //   }
  //   iterationCount++;
  // }

  return endNode;
};

export const createAddConditionNode = (newId, prevNode) => {
  let { x, y } = prevNode?.position;
  let domNodeWidth = getElementWidth(prevNode?.id) / 2;
  // let positionX = x + domNodeWidth - 105; // addConditionNode width is 210 so half of it is 105 to show in center of parent node
  let positionX = x + domNodeWidth + conditionXPosition + 30; // addConditionNode width is 210 so half of it is 105 to show in center of parent node

  let addConditionNode = {
    id: newId,
    type: "addConditionNode",
    data: { label: "Add Condition", nodeType: "addConditionNode" },
    parentId: prevNode?.parentId,
    position: {
      x: positionX || conditionXPosition,
      y: y,
    },
    className: "customNodeStyle",
  };

  return addConditionNode;
};

export const createNoneNode = (newId, prevNode, isNew = true, data = {}) => {
  let { x, y } = prevNode?.position;
  let domNodeWidth = getElementWidth(prevNode?.id) / 2;
  let positionX = x + domNodeWidth + addNodeXPosition + 30; // addConditionNode width is 210 so half of it is 105 to show in center of parent node

  let addNoneNode = {
    id: newId,
    type: "noneNode",
    data: {
      label: "None",
      nodeType: "noneNode",
      stepType: Enums.WFTemplateStepType.Condition,
      conditionId: 0, //for none condition conditionId will be 0
      ...data,
    },
    isNewNode: isNew,
    parentId: prevNode?.parentId,
    position: {
      x: positionX || conditionXPosition,
      y: y,
    },
    className: "customNodeStyle",
  };

  return addNoneNode;
};

const checkOverlap = (node, otherNode) => {
  return (
    otherNode?.type !== "endNode" &&
    Math.abs(node.position.x - otherNode.position.x) < customNodeWidth &&
    node.position.y === otherNode.position.y
  );
};
const findOverlappedNode = (node, allNodes) => {
  return allNodes.find((otherNode) => checkOverlap(node, otherNode));
};

export const createPlaceholderNode = (id, positionY) => ({
  id: makeId(id),
  type: "initial",
  data: { label: "Add action", nodeType: "initial", showCancelIcon: true },
  position: { x: defaultXPosition, y: positionY },
  className: "customNodeStyle",
});

export const findAddNodeExist = (nodes = []) => {
  return nodes.some((node) => node?.type === NodeTypeEnum.AddNode);
};

export const shallowCopy = (data) => {
  return JSON.parse(JSON.stringify(data));
};
export const calculatePosition = (node, xPosition, changeXPosition = true) => {
  const { position, type } = node;
  let nodeWidth = getElementWidth(node?.id);
  const newPosition = {
    x:
      type === NodeTypeEnum.Condition && changeXPosition
        ? getXPosition(node?.id, position?.x)
        : xPosition || defaultXPosition,
    // y: position.y + node?.height + 120,
    y:
      type === NodeTypeEnum.Condition
        ? position?.y
        : getYPosition(node?.id, position?.y),
  };
  return newPosition;
};

export const getYPosition = (nodeId, nodeYPosition) => {
  let nodeHeight = getElementHeight(nodeId);
  return nodeYPosition + nodeHeight + defaultYPosition;
};

export const getElementHeight = (id) => {
  let elements = document.getElementsByClassName("customNodeStyle");
  let selectedElement = Array.from(elements).find(
    (elem) => elem["dataset"]["id"] == id
  );
  return selectedElement?.clientHeight || 0;
};

export const getXPosition = (nodeId, nodeXPosition) => {
  let nodeWidth = getElementWidth(nodeId);
  return nodeXPosition + nodeWidth + conditionXPosition + 30;
};

export const getElementWidth = (id) => {
  let elements = document.getElementsByClassName("customNodeStyle");
  let selectedElement = Array.from(elements).find(
    (elem) => elem["dataset"]["id"] == id
  );
  return selectedElement?.clientWidth || 0;
};

export const findNode = (nodeId, nodes) => {
  return nodes.find((node) => node.id === nodeId);
};
export const findEdge = (edgeId, edges) => {
  return edges.find((edge) => edge.id === edgeId);
};

export const makeId = (oldId) => {
  return (+oldId + 1).toString();
};

export const createNode = (node) => {
  const newNode = { ...node };
  return newNode;
};

export const makeEdgeId = (source, target) => {
  return `el${source}-${target}`;
};
export const createEdge = (edge, isNewEdge = null) => {
  let id = makeEdgeId(edge.source, edge.target);
  const newEdge = {
    type: "buttonedge",
    animated: false,
    ...edge,
    id,
  };
  // setting isNewEdge for newly create edge for detecting negative id
  if (isNewEdge) {
    newEdge["isNewEdge"] = isNewEdge;
  }
  return newEdge;
};

export const updateStepNumber = (allNodes) => {
  let stepNum = 0;
  return allNodes.map((node) => {
    // no step number for delay node
    if (node?.type === NodeTypeEnum?.Delay) {
      stepNum++;
      return node;
    }
    return {
      ...node,
      data: { ...node?.data, stepNum: +node.id - stepNum },
    };
  });
};

// check for custom node type like sms, list and end node these all have custom node type
export const getNodeType = (type) => {
  return CustomNodeTypes.includes(type) ? "custom" : type;
};

export const nodeInfoGenerator = (
  { node, data },
  isMiddleNode = false,
  parentId = ""
) => {
  // id,type,position,data
  console.log("node::", node);
  // Do NOT replace initial node - always append new node
  let isInitialNode = false;
  let isDelayType = data?.nodeType === NodeTypeEnum?.Delay;

  let id = isMiddleNode ? node?.id : makeId(node?.id);
  let type = getNodeType(data?.nodeType);

  //default nodeinfo
  let nodeInfo = NodeTypes[data?.nodeType];

  let position = node?.position;
  let domNodeWidth = getElementWidth(parentId);
  if (isInitialNode || isMiddleNode) {
    position = node?.position;
    // if node type is delay and is in middle node then only change x position
    if (isDelayType) {
      position = {
        ...position,
        x: parentId ? position.x + domNodeWidth / 2 - 105 : nodeInfo?.xPosition,
      };
    }
    if (node?.type === NodeTypeEnum.Delay) {
      position.x = defaultXPosition;
    }
    if (type === NodeTypeEnum.Condition) {
      // position.x = conditionXPosition;
    }
  } else {
    let customType = type === NodeTypeEnum.Condition ? node.type : type;
    let newNodeX = getNodeX(node.type);
    position = calculatePosition(
      { ...node, type: customType },
      node?.shouldCreateNew ||
        node?.position?.x > 300 ||
        type === NodeTypeEnum.Initial
        ? node?.position?.x
        : nodeInfo?.xPosition
    );
  }
  const { groupId, ...restNode } = node;

  let newNode = createNode({
    ...restNode,
    id,
    type,
    // data: { ...node?.data, ...data },
    data: { ...data },
    position,
    isNewNode: true,
  });

  return { newNode, isInitialNode };
};

export const createEdgeId = (sourceId, targetId) => {
  let edgeId = "";
  if (sourceId) {
    let targetId = sourceId + 1;
    edgeId = makeEdgeId(sourceId, targetId);
  } else if (targetId) {
    let sourceId = targetId - 1;
    edgeId = makeEdgeId(sourceId, targetId);
  }
  return edgeId;
};

export const serverDataParser = (data = {}, initialPositionY = 20) => {
  let {
    step: { templateActions, templateConditions },
    connectionsJson,
  } = data;
  let connections = JSON.parse(connectionsJson) || {};
  let nodesData = createNodes(
    [...templateActions, ...templateConditions],
    initialPositionY
  );
  // let edgesData = createEdges(connections?.wfConnectionEdges);
  let edgesData = createEdgesFromNodeIds(
    nodesData,
    connections?.wfConnectionEdges
  );
  console.log("nodesData--", nodesData);
  console.log("edgesData--", edgesData);
  if (nodesData.length && edgesData.length) {
    nodesData = nodesData.map((node) => {
      let targetEdge = edgesData.find((edge) => edge.target == node.id); //Note: use it's source as a parentId for node
      node["parentId"] = targetEdge?.source || node?.parentId;
      return node;
    });
  }
  // setNodes(nodesData);
  return { nodesData, edgesData };
};
export const createNodes = (data, initialPositionY = 20) => {
  let nodes = [];
  if (data.length) {
    let positionY = initialPositionY;
    nodes = sortNodesByOrder(
      data.map((item) => {
        let parsedData = {};
        try {
          parsedData = typeof item?.data === "string" ? JSON.parse(item.data) : (item?.data || {});
        } catch (e) {
          console.error("Error parsing action data", e);
        }
        if (
          (parsedData?.nodeType === "appointment" || parsedData?.nodeType === NodeTypeEnum.Appointment) &&
          parsedData?.template
        ) {
          const thirdPartyId = parsedData.template.thirdPartyCalendarId;
          if (thirdPartyId && (!parsedData.template.calendarId || parsedData.template.calendarId === 0)) {
            parsedData.template.calendarId = thirdPartyId;
          }
        }
        return { ...item, data: parsedData };
      })
    );
    nodes = nodes.map((item, index) => {
      // let value = JSON.parse(item?.data);
      let value = {
        ...item?.data,
        stepId: item?.stepId,
        templateVersionNo: item?.templateVersionNo,
      };
      positionY =
        index === 0
          ? positionY
          : value?.nodeType === NodeTypeEnum.Condition ||
              value?.nodeType === NodeTypeEnum.NoneNode
            ? value?.nodePosition.y
            : positionY + smsHeight;
      let position = {
        x:
          value?.nodeType === NodeTypeEnum.Delay
            ? delayXPosition
            : value?.nodeType === NodeTypeEnum.Condition ||
                value?.nodeType === NodeTypeEnum.NoneNode
              ? value?.nodePosition?.x
              : value?.nodePosition?.x || defaultXPosition,
        y: positionY,
      };
      let nodeId = addPostfix(item?.id, value?.nodeType, item?.stepId);
      return getNode(
        {
          ...item,
          data: value,
          id: nodeId,
          // id: item?.id,
          parentId: item?.data?.parentId,
        },
        position
      );
    });
  }

  // nodes = sortNodesByOrder(nodes);

  return nodes;
};

export const getNode = (item, position) => {
  return {
    id: item?.id.toString() || "1",
    type: getNodeType(item?.data?.nodeType),
    position,
    data: item?.data,
    className: "customNodeStyle",
    parentId: item?.parentId,
    groupId: item?.groupId,
  };
};

export const createEdges = (data = []) => {
  let edges = [];
  if (data && data?.length) {
    edges = data.map((item) => {
      let info = {
        source: item?.fromStepId.toString(),
        target: item?.toStepId.toString(),
      };
      return createEdge(info);
    });
  }
  return edges;
};
export const createEdgesFromNodeIds = (nodes = [], connections) => {
  let getNodeInfo = (stepId) =>
    nodes.find((node) => node.data?.stepId === stepId);

  let edges = [];
  if (connections && connections?.length) {
    connections.forEach((item) => {
      let sourceNode = getNodeInfo(item?.fromStepId);
      let targetNode = getNodeInfo(item?.toStepId);
      let info = {
        source: sourceNode?.id.toString(),
        target: targetNode?.id.toString(),
      };

      if (
        targetNode?.type === NodeTypeEnum.Condition ||
        targetNode?.type === NodeTypeEnum.NoneNode
      ) {
        info = { ...info, type: "smoothstep" };
      }
      if (info?.source && info.target) {
        edges.push(createEdge(info));
      }
    });
  }
  return edges;

  // let edges = [];
  // if (nodes && nodes?.length > 1) {
  //   for (let i = 0; i < nodes.length - 1; i++) {
  //     let target = nodes[i]?.parentId ? nodes[i]?.parentId : nodes[i + 1]?.id;
  //     let info = {
  //       source: nodes[i].id.toString(),
  //       // target: nodes[i + 1].id.toString(),
  //       target: target.toString(),
  //     };
  //     edges.push(createEdge(info));
  //   }
  // }
  // return edges;
};

export const sortNodesByOrder = (nodes = []) => {
  let sortedNodes = [];
  if (nodes && nodes.length) {
    sortedNodes = nodes.sort((a, b) => {
      const idA = a?.data?.nodeOrder || a.id;
      const idB = b?.data?.nodeOrder || b.id;

      return idA - idB;
    });
  }
  return sortedNodes;
};

export const autoPositionNodes = (nodes = [], edges = []) => {
  let allNodes = shallowCopy(nodes);
  let allEdges = shallowCopy(edges);
  // let repositionedNodes = adjustOverlapping([...allNodes]);
  let repositionedNodes = allNodes.map((currNode, index) => {
    let prevNode = allNodes[index - 1];
    let targetEdge = allEdges.find((edge) => edge.target == currNode?.id);
    if (targetEdge && targetEdge.source) {
      prevNode = allNodes.find((n) => n?.id == targetEdge.source);
    }
    if (prevNode) {
      if (
        currNode?.type !== NodeTypeEnum.Condition ||
        (currNode?.type === NodeTypeEnum.Condition &&
          prevNode?.type !== NodeTypeEnum.Condition) ||
        (currNode?.type === NodeTypeEnum.Condition &&
          prevNode?.type === NodeTypeEnum.Condition &&
          prevNode.parentId !== currNode.parentId)
      ) {
        currNode.position.y = getYPosition(prevNode?.id, prevNode?.position?.y);
        if (currNode.type !== NodeTypeEnum.Condition) {
          let prevNodeWidth = getElementWidth(prevNode?.id) / 2;
          // in case of addConditionNode we need it's sibling to reposition it
          if (
            currNode.type === NodeTypeEnum.AddConditionNode ||
            (currNode.type === NodeTypeEnum.Initial &&
              currNode?.data?.isConditionNode)
          ) {
            let siblings = allNodes.filter(
              (node) =>
                node.parentId == currNode.parentId &&
                (node.type === NodeTypeEnum.Condition ||
                  node.type === NodeTypeEnum.AddConditionNode ||
                  node.type === NodeTypeEnum.Initial)
            );
            let siblingNode = siblings[siblings.length - 2];
            prevNodeWidth =
              siblingNode?.position?.x + getElementWidth(siblingNode?.id) / 2;
          }

          let currNodeX = getNodeX(currNode.type);
          currNode.position.x = prevNode.position.x + prevNodeWidth - currNodeX;
        }
      } else if (
        prevNode.type === NodeTypeEnum.Condition &&
        prevNode.parentId === currNode?.parentId
      ) {
        // reposition x for only condition nodes
        currNode.position.x = getXPosition(prevNode?.id, prevNode?.position?.x);
        if (currNode.type === NodeTypeEnum.Condition) {
          currNode.position.y = prevNode?.position?.y;
        }
      }
    } else {
      currNode.position.y = 35;
    }

    return currNode;
  });

  repositionedNodes = adjustOverlapping([...repositionedNodes]);

  return repositionedNodes;
};
export const generateUniqueId = () => {
  // Generate a random string
  const randomString = Math.random().toString(36).substr(2, 5);

  // Get the current timestamp
  const timestamp = new Date().getTime();

  // Combine the random string with the timestamp to create a unique ID
  // const uniqueId = `${randomString}-${timestamp}`;
  const uniqueId = `${timestamp}`;

  return uniqueId;
  // return Math.floor(Math.random() * 100);
};

export const getHighestId = (nodes = []) =>
  nodes.reduce((max, obj) => {
    let id =
      obj.type == NodeTypeEnum.AddConditionNode
        ? 0
        : removePostfix((obj?.id || "1").toString());
    return +id > max ? id : max;
  }, 0);

export const isEmptyNodeExist = (nodes = []) =>
  nodes.some((node) => node.type === NodeTypeEnum.Initial);

export const isNotValidEmailNode = (nodes = []) =>
  nodes.some(
    (node) =>
      node?.data?.nodeType === NodeTypeEnum.Email && !node?.data?.template?.from
  );

export const adjustOverlapping = (allNodes = []) => {
  let groupByPosition_Y = groupBy([...allNodes], "parentId");
  console.log("groupByPosition_Y", groupByPosition_Y);
  let rawNodes = [];
  Object.keys(groupByPosition_Y).map((key) => {
    if (
      groupByPosition_Y[key].length > 1 &&
      groupByPosition_Y[key].some(
        (node) => node.type === NodeTypeEnum.Condition
      )
    ) {
      rawNodes = groupByPosition_Y[key];
    }
  });
  if (rawNodes.length > 1) {
    let isOtherNodeExist = rawNodes.some(
      (node) =>
        node.type === "custom" ||
        node.type === NodeTypeEnum.Delay ||
        node.type === NodeTypeEnum.EndNode
    );
    let parentNode = allNodes.find((node) => node.id == rawNodes[0]?.parentId);
    let xposition = parentNode ? parentNode.position.x - 100 : 100;
    rawNodes.map((rn) => {
      // rn.position.x = xposition;
      rn.position.x = isOtherNodeExist ? rn.position.x : xposition;
      xposition = xposition + 210 + conditionXPosition + 30;
    });

    //delete addConditionNode if they are multiple in same raw
    allNodes = allNodes.filter(
      (obj, index, self) =>
        obj.type !== NodeTypeEnum.AddConditionNode ||
        index ===
          self.findIndex(
            (t) => t.type === obj.type && t.position.y === obj.position.y
          )
    );
  }
  console.log("rawNodes---", rawNodes);
  return allNodes;
};

export const addPostfix = (id, type, stepId) => {
  switch (type) {
    case NodeTypeEnum.Condition:
      return `${id + stepId}`; // for condition
    case NodeTypeEnum.NoneNode:
      return `${id + stepId}`; // for condition
    default:
      return id;
  }
};

export const removePostfix = (id = "", stepId = 0) => {
  let newId = id.includes("-") ? id.split("-")[0] : id;
  // subtracting stepId from actual id for condition node as we are adding stepId when open in edit mode
  return +newId - stepId;
};

export const getDomNodePosition = (nodeId) => {
  // Get the DOM element for a specific node by ID
  const nodeElement = document.querySelector(`[data-id="${nodeId}"]`);
  if (nodeElement) {
    const { left, top } = nodeElement.getBoundingClientRect();
    return { left: Math.round(left), top: Math.round(top) };
  }

  return null;
};

export const checkWaitEventValidation = (nodes) => {
  let templateRootNode = nodes.filter(
    (node) =>
      ![NodeTypeEnum.List, NodeTypeEnum.Trigger].includes(node?.data?.nodeType)
  )[0];
  if (
    templateRootNode?.type == NodeTypeEnum.Delay &&
    templateRootNode?.data?.actionId == Enums.WFActionType.WaitForEvent
  ) {
    toast.error(
      ToastTemplate.error(
        "Wait for SMS/Email can only be added after a corresponding SMS or Email action"
      )
    );
    return false;
  } else {
    return true;
  }
};

export const HiddenNode = {
  // id: "3420",
  type: "delay",
  data: {
    // label: "Delay",
    // count: "1",
    // unit: "Second",
    // nodeType: "delay",
    actionId: Enums.WFActionType.Hidden,
    stepType: 1,
  },
  parentId: null,
  isNewNode: true,
};

export const DummyRootNodeForTemplate = {
  // id: "3420",
  id: "1",
  type: NodeTypeEnum.DummyRoot,
  data: {
    label: "Start of Automation",
    // count: "1",
    // unit: "Second",
    nodeType: NodeTypeEnum.DummyRoot,
    actionId: Enums.WFActionType.DummyRoot,
    // stepType: 1,
  },
  position: { x: 300, y: 35 },
  className: "customNodeStyle",
};
